var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "NewUserModal",
          attrs: {
            id: "NewUserModal",
            size: "lg",
            "content-class": "menu-bg-blue-transparent-modal num-modal",
            title: "New User",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initModal()
            },
          },
        },
        [
          _c(
            "b-container",
            [
              this.user.role != "USHR Acquisition Admin"
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "py-2" }, [
                        _c(
                          "a",
                          {
                            staticClass: "link-primary float-right",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.back()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Back To User Accounts\n          "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-container",
                { staticClass: "menu-bg-blue-transparent" },
                [
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", { attrs: { for: "name" } }, [
                              _vm._v("Name *"),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                name: "name",
                                placeholder: "Name",
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("Email *"),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                name: "email",
                                placeholder: "Email",
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.form.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", [_vm._v("Organization *")]),
                            _vm._v(" "),
                            _c(
                              "b-form-select",
                              {
                                model: {
                                  value: _vm.form.org,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "org", $$v)
                                  },
                                  expression: "form.org",
                                },
                              },
                              _vm._l(this.organizations, function (org) {
                                return _c(
                                  "option",
                                  { key: org.id, domProps: { value: org.id } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(org.company_name) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", [_vm._v("Authorization *")]),
                            _vm._v(" "),
                            _c(
                              "b-form-select",
                              {
                                model: {
                                  value: _vm.form.authorization,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "authorization", $$v)
                                  },
                                  expression: "form.authorization",
                                },
                              },
                              _vm._l(this.permissions, function (obj) {
                                return _c(
                                  "option",
                                  { key: obj.id, domProps: { value: obj } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(obj.role_name) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", [_vm._v("Group * ")]),
                            _vm._v(" "),
                            _c(
                              "b-form-select",
                              {
                                model: {
                                  value: _vm.form.group,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group", $$v)
                                  },
                                  expression: "form.group",
                                },
                              },
                              _vm._l(_vm.groups, function (item) {
                                return _c(
                                  "option",
                                  {
                                    key: item.id,
                                    domProps: { value: item.group_name },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.group_name) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                        _c(
                          "div",
                          { staticClass: "field px-5" },
                          [
                            _c("label", [_vm._v("Password *")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "text",
                                        name: "password",
                                        placeholder: "Password",
                                        autocomplete: "off",
                                      },
                                      model: {
                                        value: _vm.form.password,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "password", $$v)
                                        },
                                        expression: "form.password",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "p-2" },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(
                            "\n              Note: This is an automated password and can be edited. Please copy\n              before submitting!\n            "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.user.role != "USHR Acquisition Admin"
                    ? _c(
                        "b-row",
                        { staticClass: "py-2" },
                        [
                          _c("b-col", { staticClass: "col-sm-12 px-5" }, [
                            _c(
                              "div",
                              { staticClass: "field px-5" },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      value: "True",
                                      "unchecked-value": "False",
                                    },
                                    model: {
                                      value: _vm.form.testAccount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "testAccount", $$v)
                                      },
                                      expression: "form.testAccount",
                                    },
                                  },
                                  [_vm._v("Test Account")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.feedback
                ? _c(
                    "b-row",
                    { staticClass: "p-2", attrs: { id: "feedbackWindow" } },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c(
                          "span",
                          { staticClass: "ml-1" },
                          [
                            _c("b", { staticClass: "alert alert-danger" }, [
                              _vm._v(_vm._s(this.feedback)),
                            ]),
                            _vm._v(" "),
                            _c("fa", {
                              attrs: { icon: ["fas", "window-close"] },
                              on: {
                                click: function ($event) {
                                  return _vm.feedbackHide()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formSubmitErrors.length
                ? _c(
                    "b-container",
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c(
                          "span",
                          [
                            _c("b", [
                              _vm._v("Please correct the following error(s):"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-list-group",
                              _vm._l(_vm.formSubmitErrors, function (error) {
                                return _c(
                                  "div",
                                  { key: error, staticClass: "my-2" },
                                  [
                                    _c(
                                      "b-list-group-item",
                                      { attrs: { variant: "danger" } },
                                      [_vm._v(_vm._s(error))]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.submitSuccess
                ? _c(
                    "b-row",
                    {
                      staticClass: "p-2",
                      attrs: { id: "submitSuccessWindow" },
                    },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _c(
                          "span",
                          { staticClass: "ml-3" },
                          [
                            _c("b", { staticClass: "alert alert-success" }, [
                              _vm._v(_vm._s(this.submitSuccess)),
                            ]),
                            _vm._v(" "),
                            _c("fa", {
                              attrs: { icon: ["fas", "window-close"] },
                              on: {
                                click: function ($event) {
                                  return _vm.submitSuccessHide()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-lg float-right",
                          attrs: { variant: "primary", type: "submit" },
                          on: {
                            click: function ($event) {
                              return _vm.checkForm()
                            },
                          },
                        },
                        [_vm._v("\n            Submit\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-lg float-left",
                          attrs: { variant: "secondary", type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v("\n            Clear\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }